__turbopack_context__.v({
  "className": "ibm_plex_sans_3b1e4c63-module__iolC5W__className",
});
